import React, { useState } from "react";
import Transition, {
  TransitionStatus,
} from "react-transition-group/Transition";
import Icon from "../../components/Icon";

export type CollapseItemProps = {
  onClick?: () => void;
  main: string;
  children: React.ReactElement;
  className?: string;
};

const CollapseItem: React.FunctionComponent<CollapseItemProps> = ({
  main,
  className,
  onClick,
  children,
}): React.ReactElement => {
  const [dropDown, setDropDown] = useState(false);
  const duration = 150;
  const transitionStyles: Record<TransitionStatus, Record<string, unknown>> = {
    entering: { opacity: 0, maxHeight: 0, zIndex: -5 },
    entered: { opacity: 1, zIndex: 10 },
    exiting: { opacity: 0 },
    exited: { opacity: 0, maxHeight: 0, zIndex: -5 },
    unmounted: {},
  };
  const style = {
    paddingBottom: dropDown ? "1.25rem" : "",
    zIndex: dropDown ? "1" : "",
  };
  const defaultStyle = {
    transition: `all 0.3s ease-in-out`,
  };

  const handleClick = (): void => {
    setDropDown(!dropDown);
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className="collapseItem" onClick={handleClick} style={style}>
      <div className={`${className}`}>
        <h4 className={`collapseItem__header`}>
          <span className="collapseItem__headerText">{main}</span>
          <Icon
            className="collapseItem__icon"
            icon={dropDown ? "UP_ARROW" : "DOWN_ARROW"}
            color="greyish-brown"
            width="30"
          />
        </h4>
        <Transition in={dropDown} timeout={duration} appear={true}>
          {(state) => (
            <div
              className="collapseItem__content"
              style={{
                ...defaultStyle,
                ...transitionStyles[state],
              }}
            >
              {children}
            </div>
          )}
        </Transition>
      </div>
    </div>
  );
};

export default CollapseItem;
